import { css } from 'lit';

export const styles = css `
  :host {
    flex-wrap: wrap;
  }
`;
